/**
 * Connection status for the XiCafe internet card.
 *
 * Defined independently of the GetSlash module's `ConnectionStatus` enum so
 * the two providers can evolve and be removed independently. Values are
 * string-valued and match the xapp's `ConnectionStatus` enum verbatim.
 */
export enum ConnectionStatus {
  Unknown = 'Unknown',
  NoConnection = 'NoConnection',
  Connected = 'Connected',
  Active = 'Active',
  Paused = 'Paused',
  Exhausted = 'Exhausted',
}
